import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function FilterIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Union" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M13.4664 2.9916c-0.5192 2.70402 -2.1392 4.88661 -4.65073 5.61552v3.18398c0 0.4169 -0.2475 0.794 -0.63004 0.96l-1.52346 0.6611c-0.69141 0.3001 -1.46393 -0.2065 -1.46393 -0.9599V8.60711C2.68672 7.87819 1.05316 5.69561 0.534044 2.9916 0.303353 1.78997 1.27457 0.9372 2.55417 0.788319c3.3676 -0.391808 5.31957 -0.376971 8.89203 0 1.2643 0.133404 2.2509 1.001651 2.0202 2.203281Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
